import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-user-select-dialog',
  templateUrl: './user-select-dialog.component.html',
  styleUrls: ['./user-select-dialog.component.scss']
})
export class UserSelectDialogComponent  extends DialogContentBase implements OnInit {

  constructor( public dialog: DialogRef,
    private fb:UntypedFormBuilder) {   super(dialog);  }

  @Input() label:string;
  @Input() selectedUserId:string;
  form: UntypedFormGroup;

  ngOnInit(): void {
    if(!this.selectedUserId){
      this.selectedUserId = '';
    }
    this.form = this.getForm();
  }

  confirm(){
    const result = this.form.controls['selectedUserId'].value;
        this.dialog.close({ text: 'OK' , selectedUserId: result});
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  getForm( ) {
    return this.fb.group({
      selectedUserId: [this.selectedUserId, Validators.required],
    });
  }
}
